module.exports = __webpack_public_path__ + "img/calender_date.b2307993.svg";